// Radha — shared status-severity color mapping. Uses the validated status scale
// in theme.css (--status-good/warning/serious/critical). Always pair with a
// visible text label — see the token comments in theme.css for why (the
// validator's mitigation, not a style choice).
import type { RiskBand } from "../types/collections";

export function riskBandColor(band: RiskBand): string {
  switch (band) {
    case "critical": return "var(--status-critical)";
    case "high": return "var(--status-serious)";
    case "medium": return "var(--status-warning)";
    default: return "var(--status-good)";
  }
}
